import { useEffect, useMemo, useState } from 'react';
import { getSavedLanguage, type SupportedLanguage } from './languageSettings';
import { translate, type TranslationKey } from './i18n';

export function useLanguage() {
  const [language, setLanguage] = useState<SupportedLanguage>(() => getSavedLanguage());

  useEffect(() => {
    const handleStorage = () => setLanguage(getSavedLanguage());
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const t = useMemo(
    () => (key: TranslationKey) => translate(language, key),
    [language]
  );

  return { language, t };
}
